import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] text-center px-4 bg-surface">
      <div className="relative mb-8">
        <h1 className="text-8xl md:text-9xl font-black text-primary/10 select-none">
          404
        </h1>
        <div className="absolute inset-0 flex items-center justify-center">
          <i className="ri-error-warning-line text-5xl md:text-6xl text-accent" />
        </div>
      </div>
      <h2 className="text-xl md:text-2xl font-bold text-primary mb-3">
        页面未找到
      </h2>
      <p className="text-sm md:text-base text-text-muted mb-8 max-w-md">
        您访问的页面不存在或已被移除。请返回首页或浏览其他内容。
      </p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 px-8 py-3 bg-accent text-white font-semibold rounded-lg hover:bg-accent-dark transition-colors"
      >
        <i className="ri-home-line" />
        返回首页
      </Link>
    </div>
  );
}
